/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_List_Name_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Enter a list name here" |
*
* @param {Markers_List_Name_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_list_name_placeholder = /** @type {((inputs?: Markers_List_Name_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_List_Name_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisir un nom de liste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie hier einen Listennamen ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci qui un nome per l'elenco")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите название списка здесь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Introduzca un nombre de lista aquí")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("在此处输入列表名称")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ここにリスト名を入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यहां सूची का नाम दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira aqui o nome da lista")
	return /** @type {LocalizedString} */ ("Enter a list name here")
});